module.exports = __webpack_public_path__ + "static/media/preservacao-icon.1456a7d5.svg";